// src/pages/dashboard/section-stok/SectionStok.jsx
import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import RimenderStock from "../../inventory/rimender-stock/RimenderStock";

function SectionStok({ paperShadow }) {
    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                    <StoreMallDirectoryOutlinedIcon sx={{ fontSize: 32, color:"#607D8B" }} />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Stok
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Deskripsi
                        </Typography>
                    </Box>
                </Stack>
                <Typography variant="body1" color="text.primary">
                    <RimenderStock/>
                </Typography>
        </Paper>
    );
}

export default SectionStok;